import type { EmailServiceSubmitFormRequest } from 'apiConnector/email-service';
import type { EmailServicePreviewState } from 'models/emailService/EmailServicePreviewState';

type EmailServiceSendStatus = 'NOT_YET_SENT' | 'SENDING' | 'SENT' | 'SEND_FAILED' | 'SUBMISSION_FAILED';

type EmailServiceInactiveState = {
  status: 'INACTIVE';
};
export type EmailServiceActiveState = EmailServiceSubmitFormRequest & {
  status: 'ACTIVE';
  sendStatus: EmailServiceSendStatus;
  warnings: readonly string[];
  errors: readonly string[];
  preview: EmailServicePreviewState;
};

export type EmailServiceState = Readonly<EmailServiceInactiveState | EmailServiceActiveState>;

export const initialEmailServiceState: EmailServiceState = {
  status: 'INACTIVE',
};
